<template>
  <div class="w-full bg-white height-100">
    <!-- <el-drawer
      title=""
      :visible.sync="drawer"
      :direction="direction"
      @close="closeSlidesr"
    >
      <template slot="title"
        ><h3 class="text-xl Add Products text-white">Templates</h3></template
      >
      <Drawer
        @closePopup="closeSlidesr"
        :clearData="clearData"
        @editL="editL"
      />
    </el-drawer>
    <el-drawer
      title=""
      :visible.sync="drawer2"
      :direction="direction"
      @close="closeSlidesr"
    >
      <template slot="title"
        ><h3 class="text-xl Add Products text-white">
          Templates sss
        </h3></template
      >
      <Drawer2 />
    </el-drawer> -->
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl font-semibold">
            Create Landing Page
          </h2>
        </div>
      </div>
    </div>
    <div class="px-6 py-8 menucontrol-scroll fixed-top bg-white">
      <div>
        <h4 class="text-4f4f4f font-semibold fsize20 mb-0">Pick a Template</h4>
        <p class="text-8f8f8f fsize14">Select a layout for your Landing Page</p>
      </div>

      <div class="flex gap-8 mt-8">
        <div>
          <img
            @click="handleClick('controlcenter-Templatelayout1')"
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/template1.png"
            alt="templates"
            class="tempselect-cs"
          />
        </div>
        <div>
          <img
            @click="handleClick('controlcenter-Templatelayout2')"
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/master/emailTemplates/temp2.png"
            alt="templates"
            class="tempselect-cs"
          />
        </div>
        <div>
          <img
            @click="handleClick('controlcenter-Templatelayout3')"
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/master/emailTemplates/temp3.png"
            alt="templates"
            class="tempselect-cs"
          />
        </div>
        <div>
          <img
            @click="handleClick('controlcenter-Templatelayout4')"
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/master/emailTemplates/temp4.png"
            alt="templates"
            class="tempselect-cs"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Drawer from "../components/Drawer.vue";
// import Drawer2 from "../components/Drawer2.vue";
export default {
  data() {
    return {
      clearData: {},
      drawer: false,
      drawer2: false,

      AddPage: false,
    };
  },
  components: {},
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    closeSlidesr() {
      let clear = {
        pageName: null,
        content: null,
        content2: null,
        type: null,
        datavalue: [],
      };
      this.clearData = clear;
      this.drawer = false;
    },

    selectedTemp(data, limit) {
      this.$store.state.landingPage.templateName = data;
      this.$store.state.landingPage.imageLimit = limit;
      // if (data == "temp1") {
      this.drawer = true;
      // } else {
      //   this.drawer2 = true;
      // }
    },
    closeSlider() {
      this.drawer = false;
      this.$store.dispatch("landingPage/getAllLandingPage");
    },

    editL() {
      this.AddPage = true;
    },
  },
};
</script>
>
